import request, { REQUEST_METHODS } from '@api/Request';
import { RibitsEndpoints } from './config';
import { BankSiteKey, GetBankSiteListResponse, GetIlfProgramListResponse, IlfProgramKey } from './types';

export default class RibitsService {
  public static readonly getBankSiteList = (key: BankSiteKey, value: string): Promise<GetBankSiteListResponse> =>
    request({
      url: RibitsEndpoints.getBankSiteList(key, value),
      method: REQUEST_METHODS.GET,
    });

  public static readonly getIlfProgramList = (key: IlfProgramKey, value: string): Promise<GetIlfProgramListResponse> =>
    request({
      url: RibitsEndpoints.getIlfProgramList(key, value),
      method: REQUEST_METHODS.GET,
    });

  public static readonly getMitigationBanksOrIlf = (
    mitigationType: string,
    latitude: number,
    longitude: number
  ): Promise<any> =>
    request({
      baseURL: import.meta.env.VITE_REDIRECT_URL,
      url: RibitsEndpoints.getMitigationBanksOrIlf(mitigationType, latitude, longitude),
      method: REQUEST_METHODS.GET,
    });
}
